import { http } from './query';

const getUnsubscribeDetails = async ({ id }) => {
  const response = await http.get(`/s/${id}`);
  return response.data;
};

const unSubscribe = async ({ id }) => {
  const response = await http.get(`/u/${id}`);
  return response.status;
};

export { getUnsubscribeDetails, unSubscribe };
